import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentUrlService } from './environment-url.service';
import { AdalService } from 'adal-angular4';
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { isNullOrUndefined } from 'util';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RepositoryService {

  private authHeaders: HttpHeaders;
  private uploadFileAuthHeaders: HttpHeaders;
  private tokenResource: string;
  public user: RiskUser;
  public riskUsers: RiskUser[];
  public userIsSetup: boolean;
  public loggedInAzure: boolean;
  private personId: number;
  private jwt: string;

  public user$: BehaviorSubject<RiskUser> = new BehaviorSubject<RiskUser>(null);

  constructor(private http: HttpClient, private envUrl: EnvironmentUrlService, private adalService: AdalService) {
    this._setAuthHeaders();
    this._setFileUploadAuthHeaders();
    this.user = new RiskUser;
    this.user.superAdmin = 0;
    this.user.admin = 0;
    this.loggedInAzure = false;
    this.userIsSetup = false;
  }

  public SetupPeople() {
    if (isNullOrUndefined(this.riskUsers)) {
      this.getPeople();
    }
  }
  public getPeople() {
    let apiAddress: string = `Users`;
    this.getData(apiAddress)
      .subscribe(res => {
        this.riskUsers = res as RiskUser[];
      });
  }

  public getPersonNameById(id: number) {
    if (isNullOrUndefined(id)) { return '.' }

    this.personId = id;
    if (isNullOrUndefined(this.riskUsers)) { return "." }

    const person = this.riskUsers.filter(this.hasId)[0]; //  filter to find user with matching Id
    return person.firstname + ' ' + person.surname;
   }

  public hasId = (element, index, array) => {
    return (element.id === this.personId);
  };

  public GetMyUser() {
    if (this.IsUserSetup() === false) {
      this.SetUpMyUser();
    }
    return this.user$.value;
  }

  public SetUpMyUser() {
    const apiAddress: string = `Users/MyUser`;
    this.getData(apiAddress)
      .subscribe(res => {
        this.user = res as RiskUser;
        this.user$.next(this.user);
        this.userIsSetup = true;
      });
  }

  public IsUserSetup(): boolean {
    return this.userIsSetup;
  }

  public GetMyUserRemote() {
    const apiAddress: string = `Users/MyUser`;
    return this.getData(apiAddress);
  }

  public getData(route: string) {
    if (this.jwt.length < 5) {
      this.adalService.login();
      this._setAuthHeaders();
    }

    const temp = this.createCompleteRoute(route, this.envUrl.riskApiAddress);
    return this.http.get(this.createCompleteRoute(route, this.envUrl.riskApiAddress), { headers: this.authHeaders });
  }

  public getFileData(route: string) {
    const temp = this.createCompleteRoute(route, this.envUrl.riskApiAddress);
    return this.http.get(this.createCompleteRoute(route, this.envUrl.riskApiAddress), { headers: this.authHeaders, responseType: 'blob' });
  }

  public create(route: string, body) {
    return this.http.post(this.createCompleteRoute(route, this.envUrl.riskApiAddress), body, { headers: this.authHeaders });

  }

  public uploadFile(route: string, body) {
    return this.http.post(this.createCompleteRoute(route, this.envUrl.riskApiAddress),
      body,
      { headers: this.uploadFileAuthHeaders });
  }

  public update(route: string, body) {
    return this.http.put(this.createCompleteRoute(route, this.envUrl.riskApiAddress), JSON.stringify(body), { headers: this.authHeaders });
  }

  public delete(route: string) {
    return this.http.delete(this.createCompleteRoute(route, this.envUrl.riskApiAddress), { headers: this.authHeaders });
  }

  private createCompleteRoute(route: string, envAddress: string) {
    return `${envAddress}/${route}`;
  }

  private _setAuthHeaders(token_type = 'Bearer') {
    this.jwt = this.adalService.userInfo.token;

    this.authHeaders = new HttpHeaders({
      'Content-Type':
        'application/json',
      'Authorization': 'Bearer ' + this.jwt,
      'crossdomain': 'true'
    });

  }

  private _setFileUploadAuthHeaders(token_type = 'Bearer') {
    let jwt = this.adalService.userInfo.token;

    this.uploadFileAuthHeaders = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + jwt
    });

  }




}
